import React, { Fragment, useState } from "react"
import { Helmet } from "react-helmet"
import { Link } from "react-router-dom"





//componets
import ThemeMenuThree from "../../../components/header/ThemeMenuThree"
import PageTitle from "../../../components/page-title/PageTitle"
import SearchForm from "../../../components/form/SearchForm"
import CategoryWidgetTwo from "../../../components/widget/CategoryWidgetTwo"
import WidgetPost from "../../../components/widget/WidgetPost"
import CategoryTag from "../../../components/widget/CategoryTag"
import BlogAuthor from "../../../components/blog/BlogAuthor"
import ModalVideos from "../../../components/modal-video/ModalVideos"
import SocialMedia from "../../../components/blog/SocialMedia"
import BlogAuthorTwo from "../../../components/blog/BlogAuthorTwo"
import BlogComment from "../../../components/blog/BlogComment"
import CommentForm from "../../../components/form/CommentForm"
import NewsletterTwo from "../../../components/call-to-action/NewsletterTwo"
import FooterThree from "../../../components/footer/FooterThree"




const BlogDetailsV2 = () => {
    const [open, setOpen] = useState(false);
    const OpenModal = () => {
        setOpen(!open)
    }

    return (
        <Fragment>
            <ModalVideos isOpen={open} onClick={OpenModal} />
            <div className="main-page-wrapper">
                {/* Helmet start */}
                <Helmet>
                    <title>Artículo Detallado – Blog CuySoft</title>
                    <meta name="description" content="Artículo completo sobre tecnología, desarrollo de software y ciberseguridad en Ecuador." />
                    <link rel="canonical" href="https://www.cuysoft.com/blog-details-v2" />
                </Helmet>
                {/* Helmet end */}

                {/* ThemeMenuThree */}
                <ThemeMenuThree />
                {/* ThemeMenuThree */}

                {/* PageTitle */}
                <PageTitle title="Detalles del Blog Dos" />
                {/* PageTitle */}

                {/*blog-single-area start*/}
                <section className="blog-single-area pt-150 pb-80 pt-lg-60">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-8 mb-60">
                                <div className="blog-style-five mb-25">
                                    <div className="blog-content">
                                        <div className="blog-tag pb-15">
                                            Investigación , Tecnología
                                        </div>
                                        <h3><Link className="blog-title" to="/blog-details-v1">Google está eliminando la sección de Películas y TV de la Play Store</Link></h3>
                                        <div className="blog-meta mb-35">
                                            <a href="#" className="mr-20"><i className="bi bi-person-plus" /> Samir Jam</a>
                                            <a href="#"><i className="bi bi-clock" /> 21 Ene 2022</a>
                                        </div>
                                    </div>
                                    <div className="blog-thumb mb-40">
                                        <img className="w-100" src="assets/img/blog/blog-21.jpg" alt="blog-img" />
                                    </div>
                                    <p className="text-white mb-25">Integramos continuamente funcionalidades físicas y digitales
                                        frente a
                                        un ancho de banda
                                        de alta calidad. Pontificamos de manera monotécnica sobre experiencia distintiva en lugar de tecnologías
                                        covalentes. Generamos continuamente mercados de nicho escalables sin
                                        vórtices empresariales. Paralelizamos objetivamente soluciones escalables antes de
                                        altos estándares en participación mental. Desplegamos de manera creíble plataformas verticales frente a
                                        nichos de calidad.</p>
                                    <p className="text-white">Integramos continuamente funcionalidades físicas y digitales frente a
                                        un ancho de banda
                                        de alta calidad. Pontificamos de manera monotécnica sobre experiencia distintiva en lugar de tecnologías
                                        covalentes. Generamos continuamente nichos escalables.</p>
                                </div>
                                {/* BlogAuthor start */}
                                <BlogAuthor bgColor="theme-bg" />
                                {/* BlogAuthor end */}
                                <div className="blog-single-content">
                                    <p className="text-white">Integramos continuamente funcionalidades físicas y digitales frente a
                                        un ancho de banda
                                        de alta calidad. Pontificamos de manera monotécnica sobre experiencia distintiva en lugar de tecnologías
                                        covalentes. Generamos continuamente mercados de nicho escalables sin vórtices
                                        empresariales. Paralelizamos objetivamente soluciones escalables antes de altos estándares en
                                        participación mental. Desplegamos de manera creíble plataformas verticales frente a nichos de calidad.</p>
                                    <h3 className="sect-title-two mb-40 mt-50">01.¿Por qué cancelar esos?</h3>
                                    <p className="text-white">Integramos continuamente funcionalidades físicas y digitales frente a
                                        un ancho de banda
                                        de alta calidad. Pontificamos de manera monotécnica sobre experiencia distintiva en lugar de tecnologías
                                        covalentes. Generamos continuamente mercados de nicho escalables sin vórtices
                                        empresariales. Paralelizamos objetivamente soluciones escalables antes de altos estándares en
                                        participación mental. Desplegamos de manera creíble plataformas verticales frente a nichos de calidad.</p>
                                    <div className="row gx-4 gx-xxl-5 px-0 mt-30">
                                        <div className="col-sm-6 mb-30">
                                            <img className="w-100" src="assets/img/blog/blog-25.jpg" alt="blog-img" />
                                        </div>
                                        <div className="col-sm-6 mb-30">
                                            <img className="w-100" src="assets/img/blog/blog-26.jpg" alt="blog-img" />
                                        </div>
                                    </div>
                                    <p className="text-white mb-30">Integramos continuamente funcionalidades físicas y digitales
                                        frente a
                                        un ancho de banda
                                        de alta calidad. Pontificamos de manera monotécnica sobre experiencia distintiva en lugar de tecnologías
                                        covalentes. Generamos continuamente mercados de nicho escalables sin vórtices
                                        empresariales. Paralelizamos objetivamente soluciones escalables antes de altos estándares en
                                        participación mental. Desplegamos de manera creíble plataformas verticales frente a nichos de calidad.</p>
                                    <ul className="text-list list-none">
                                        <li>Explotamos de manera convincente vórtices B2B con vinculación total emergente.</li>
                                        <li>Personalizamos enérgicamente la participación mental sin errores con nichos estratégicos.</li>
                                        <li>Conectamos de manera fosfluorescente negocios electrónicos y mercados electrónicos en lugar de mercados.
                                        </li>
                                        <li>Agregamos globalmente innovación ubicua y usuarios impulsados por el mercado. </li>
                                    </ul>
                                    <h3 className="sect-title-two mb-40 mt-25">02.Sobre el próximo desafío de Google</h3>
                                    <p className="text-white">Integramos continuamente funcionalidades físicas y digitales
                                        frente a
                                        un ancho de banda de alta calidad. Pontificamos de manera monotécnica sobre experiencia distintiva en lugar de
                                        tecnologías covalentes. Generamos continuamente nichos escalables.</p>
                                    <p className="text-white mt-25">Integramos continuamente funcionalidades físicas y digitales
                                        frente a
                                        un ancho de banda
                                        de alta calidad. Pontificamos de manera monotécnica sobre experiencia distintiva en lugar de tecnologías
                                        covalentes. Generamos continuamente mercados de nicho escalables sin vórtices
                                        empresariales. Paralelizamos objetivamente soluciones escalables antes de altos estándares en
                                        participación mental. Desplegamos de manera creíble plataformas verticales frente a nichos de calidad.</p>
                                    <div className="service-video">
                                        <div className="service-single-video mt-30 mb-30">
                                            <img className="w-100" src="assets/img/blog/blog-27.jpg" alt="img" />
                                            <a className="popup-video mb-30" onClick={OpenModal} ><i className="bi bi-play-fill" /></a>
                                        </div>
                                    </div>
                                    <p className="text-white">Integramos continuamente funcionalidades físicas y digitales frente a
                                        un ancho de banda
                                        de alta calidad. Pontificamos de manera monotécnica sobre experiencia distintiva en lugar de tecnologías
                                        covalentes. Generamos continuamente mercados de nicho escalables sin vórtices
                                        empresariales. Paralelizamos objetivamente soluciones escalables antes de.</p>
                                    <h3 className="sect-title-two mb-40 mt-50">03.Conclusión</h3>
                                    <p className="text-white">Integramos continuamente funcionalidades físicas y digitales frente a
                                        un ancho de banda de alta calidad. Pontificamos de manera monotécnica sobre experiencia distintiva en lugar de
                                        tecnologías covalentes. Generamos continuamente mercados de nicho escalables sin
                                        vórtices empresariales. Paralelizamos objetivamente soluciones escalables antes de altos
                                        estándares en participación mental. Desplegamos de manera creíble plataformas verticales frente a nichos de
                                        calidad.
                                    </p></div>
                                {/* SocialMedia start */}
                                <SocialMedia bgColor="theme-bg" />
                                {/* SocialMedia end */}

                                {/* BlogAuthorTwo start */}
                                <BlogAuthorTwo />
                                {/* BlogAuthorTwo end */}
                                <div className="comments-wrapper  mt-55">
                                    <h3 className="post-title mb-50">Comentarios</h3>
                                    {/* BlogComment start */}
                                    <BlogComment />
                                    {/* BlogComment end */}
                                </div>
                                <div className="comment-form mb-10 mt-65">
                                    <h3 className="post-title mb-35">Deja un comentario</h3>
                                    {/* CommentForm start */}
                                    <CommentForm />
                                    {/* CommentForm end */}
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="right-widget-section">
                                    <div className="widget widget-search mb-60">
                                        <div className="widget-title-box mb-30">
                                            <h4 className="widget-sub-title2 fs-20">Buscar Aquí</h4>
                                        </div>
                                        {/* SearchForm start */}
                                        <SearchForm />
                                        {/* SearchForm end */}
                                    </div>
                                    <div className="widget widget-categories-list mb-40">
                                        <div className="widget-title-box mb-30">
                                            <h4 className="widget-sub-title2 fs-20">Categorías</h4>
                                        </div>
                                        {/* CategoryWidgetTwo start */}
                                        <CategoryWidgetTwo />
                                        {/* CategoryWidgetTwo end */}
                                    </div>
                                    <div className="widget widget-post mb-60">
                                        <div className="widget-title-box mb-30">
                                            <h4 className="widget-sub-title2 fs-20">Publicaciones Recientes</h4>
                                        </div>
                                        {/* WidgetPost start */}
                                        <WidgetPost />
                                        {/* WidgetPost end */}
                                    </div>
                                    <div className="widget widget-categories-tag mb-60">
                                        <div className="widget-title-box mb-25">
                                            <h4 className="widget-sub-title2 fs-20">Etiquetas</h4>
                                        </div>
                                        {/* CategoryTag start */}
                                        <CategoryTag />
                                        {/* CategoryTag end */}
                                    </div>
                                    <div className="widget widget-post mb-60">
                                        <div className="widget-title-box mb-30">
                                            <h4 className="widget-sub-title2 fs-20">Publicaciones Populares</h4>
                                        </div>
                                        {/* WidgetPost start */}
                                        <WidgetPost />
                                        {/* WidgetPost end */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*blog-single-area end*/}

                {/*cuysoft-newsletter start*/}
                <NewsletterTwo />
                {/*cuysoft-newsletter end*/}

                {/* FooterThree start */}
                <FooterThree />
                {/* FooterThree end */}

            </div>

        </Fragment>
    )
}

export default BlogDetailsV2